import React, {useEffect, useState} from "react";
import {Avatar, Card, Row, Spin, Tag} from "antd";
import {Link} from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Api from "../../api";

dayjs.extend(relativeTime);

const getPostsFromResponse = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    return [];
};

const getPostBody = (post) => post.body || post.content || post.text || "";

const getPostUser = (post) => post.user || post.author || {};

const getPostType = (post) => post.type || post.post_type || post.feed_type || "";

const LatestFeedPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        Api.get("/v3/feed/posts", {
            per_page: 5,
            page: 1,
        })
            .then((res) => {
                setPosts(getPostsFromResponse(res.data));
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <Card
            className="dashboard-feed-card"
            title={
                <Row type="flex" align="middle" justify="space-between">
                    <span>Latest feed posts</span>
                </Row>
            }
            bordered={false}
        >
            {loading ? (
                <Spin/>
            ) : posts.length === 0 ? (
                <div className="feed-item__empty">No feed posts</div>
            ) : (
                <div className="feed-list">
                    {posts.map((item) => {
                        const user = getPostUser(item);
                        const body = getPostBody(item);
                        const postType = getPostType(item);
                        const userId = user.user_id || user.id;
                        const userName = user.name_f || user.name || "Unknown";
                        const createdAt = item.created_at || item.published_at;

                        return (
                            <div key={item.id} className="feed-item">
                                <div className="feed-item__comment">
                                    <Avatar size="small" src={user.avatar}>
                                        {userName.charAt(0)}
                                    </Avatar>

                                    <div className="feed-item__main">
                                        <div className="feed-item__row">
                                            {userId ? (
                                                <Link className="feed-item__title" to={`/user/${userId}`}>
                                                    {userName}
                                                </Link>
                                            ) : (
                                                <span className="feed-item__title">{userName}</span>
                                            )}
                                            {createdAt && (
                                                <Tag>{dayjs(createdAt).fromNow()}</Tag>
                                            )}
                                        </div>

                                        {body && (
                                            <p className="feed-item__text" title={body}>
                                                {body}
                                            </p>
                                        )}

                                        {postType && (
                                            <span className="feed-item__type">{postType}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </Card>
    );
};

export default LatestFeedPosts;
